import api from '@pray/shared/utils/api';

import type { SuperFunnelContractStatus, SuperFunnelProductType } from './getAccounts';

export type SuperFunnelContractChanges = {
  status?: SuperFunnelContractStatus;
  product_type?: SuperFunnelProductType;
  contract_date?: string | null;
  service_start_date?: string | null;
  billing_start_date?: string | null;
  cancel_date?: string | null;
  contract_term_months?: number | null;
  target_spend_pct?: string | number | null;
  exception_flag?: boolean;
  exception_notes?: string | null;
  total_budget_cents?: number | null;
  cpm_cents?: number | null;
  service_fee_percent?: string | number | null;
};

export type PatchSuperFunnelContractParams = {
  contractId: string;
  changes: SuperFunnelContractChanges;
  reason?: string;
};

export type PatchedSuperFunnelContract = {
  id: string;
  artist_id: string | null;
  status: SuperFunnelContractStatus | null;
  product_type: SuperFunnelProductType | null;
  types?: SuperFunnelProductType[];
  exception_flag: boolean;
  exception_notes: string | null;
  contract_date: string | null;
  service_start_date: string | null;
  billing_start_date: string | null;
  cancel_date: string | null;
  contract_term_months: number | null;
  target_spend_pct: string | null;
  total_budget_cents: number | null;
  cpm_cents: number | null;
  service_fee_percent: string | null;
};

export type PatchSuperFunnelContractResponse = {
  contract: PatchedSuperFunnelContract;
  audit_ids: string[];
  changed_fields: string[];
};

export const patchContract = async ({
  contractId,
  changes,
  reason,
}: PatchSuperFunnelContractParams): Promise<PatchSuperFunnelContractResponse> => {
  const url = `/web/studio/superfunnel/contracts/${contractId}`;

  const body: Record<string, unknown> = { changes };
  if (reason !== undefined) body.reason = reason;

  const response = await api.executePatchRequest(url, body);

  return (response.data as { data: PatchSuperFunnelContractResponse }).data;
};
